import { Injectable, inject } from '@angular/core';
import { WrappedHttpErrorResponse } from '@app/errors/wrapped-error';
import { EditService } from 'app/pfm-shared/services/edit.service';
import { Observable, of, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ProjectAssetMappingBulkService } from './project-asset-mapping-bulk.service';

@Injectable({ providedIn: 'root'})
export class ProjectAssetMappingCostCenterService extends EditService {
  private bulkService = inject(ProjectAssetMappingBulkService);

  constructor() {
    super('ProjectAssetMappings', ['ProjectAssetMappingId']);
    this.excludedPropertiesFromSave = ['CostCenter'];
  }

  public saveChanges$(): Observable<any> {
    if (!this.hasChanges()) return of([]);

    let result =
      this.bulkService
        .saveChanges$(this.deletedItems, this.updatedItems, this.excludedPropertiesFromSave, this.createdItems)
        .pipe(
          map(response => {
            this.reset();
            this.read(this.state, this.queryString);
            return response;
          }),
          catchError(error => {
            this.errorService.error('Error Saving Changes', error);
            return throwError(new WrappedHttpErrorResponse('Error Saving', error));
          })
        );

    return result;
  }
}